import DataModel from '../../common/model/DataModel';

import PreferenceManager from '../../application/PreferenceManager';

export default class OfferSelectSummaryDataModel extends DataModel {
    constructor(preferenceGroupName) {
        super();

        this.preferenceGroupName = preferenceGroupName;

        this.isNotifyEnabled = PreferenceManager.retrieveValue(
            this.preferenceGroupName,
            PreferenceManager.isNotifyEnabled,
            false
        );

        this.isEmailCheckboxVisible = false;
    }

    onPropertyUpdated(propertyName, oldValue, newValue) {
        switch (propertyName) {
            case 'isNotifyEnabled':
                PreferenceManager.updateValue(
                    this.preferenceGroupName,
                    PreferenceManager.isNotifyEnabled,
                    newValue
                );
                break;
            default:
                break;
        }
    }
}